/**
 * Get the effective game date.
 * Before 8 AM EST, show yesterday's games since late games may have just finished.
 * After 8 AM EST, show today's games.
 *
 * @returns {string} Date string in YYYY-MM-DD format
 */
export function getEffectiveGameDate() {
  const now = new Date();

  // Get EST date components directly (handles DST automatically)
  const estYear = parseInt(now.toLocaleString('en-US', { timeZone: 'America/New_York', year: 'numeric' }));
  const estMonth = parseInt(now.toLocaleString('en-US', { timeZone: 'America/New_York', month: '2-digit' }));
  const estDay = parseInt(now.toLocaleString('en-US', { timeZone: 'America/New_York', day: '2-digit' }));
  const estHour = parseInt(now.toLocaleString('en-US', { timeZone: 'America/New_York', hour: '2-digit', hour12: false }));

  // If before 8 AM EST, use yesterday's date
  if (estHour < 8) {
    const yesterday = new Date(estYear, estMonth - 1, estDay);
    yesterday.setDate(yesterday.getDate() - 1);
    const y = yesterday.getFullYear();
    const m = String(yesterday.getMonth() + 1).padStart(2, '0');
    const d = String(yesterday.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  // Otherwise use today's EST date
  const m = String(estMonth).padStart(2, '0');
  const d = String(estDay).padStart(2, '0');
  return `${estYear}-${m}-${d}`;
}
